<ng-container *transloco="let t;">
<app-list-view [title]="t('common.labels.competences')" [messages]="messages" [loading]="loading">

  <div buttons>
    <div *ngIf="inOrdering !== true">
      <button withRight="admin.competence.list"pButton (click)="onReload()" type="button" icon="pi pi-refresh" class="p-button-secondary p-button-outlined p-mb-2" aria-label="{{ t('common.labels.reload_list') }}" pTooltip="{{ t('common.labels.reload_list') }}" tooltipPosition="left"></button>
      <button withRight="admin.competence.create" pButton (click)="onNew()" type="button" icon="pi pi-plus" label="{{ t('common.labels.new') }}" class="p-button-success p-ml-2 p-mb-2"></button>
      <button *ngIf="items.length > 0" pButton type="button" (click)="menu.toggle($event)" icon="pi pi-bars" class="p-button-outlined p-button-secondary p-mb-2 p-ml-2" aria-label="{{ t('common.labels.more_functions') }}"></button>
      <p-menu #menu [popup]="true" [model]="items"></p-menu>
    </div>
    <div class="p-text-right" *ngIf="inOrdering === true">
      <form (submit)="onSubmit()" novalidate>
        <app-form-buttons [submitting]="submitting" (cancelled)="onCancel()"></app-form-buttons>
      </form>
    </div>
  </div>

  <div table>
    <p-table
      [value]="competences"
      [paginator]="true"
      [rows]="20"
      stateStorage="local"
      stateKey="competence-list"
      [rowsPerPageOptions]="rowsPerPage"
      [showCurrentPageReport]="true"
      [currentPageReportTemplate]="t('common.labels.current_page_report')"
      [reorderableColumns]="inOrdering === true"
      (onRowReorder)="onRowReorder($event)"
    >
      <ng-template pTemplate="header">
        <tr>
          <th style="width: 3rem" *ngIf="inOrdering === true"></th>
          <th>{{ t('common.labels.name') }}</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-competence let-index="rowIndex">
        <tr hoverOnRight="admin.competence.show" [pReorderableRow]="index">
          <td *ngIf="inOrdering === true">
            <span class="pi pi-bars" pReorderableRowHandle></span>
          </td>
          <td *ngIf="inOrdering !== true" (click)="onOpen(competence)" (keyup.enter)="onOpen(competence)" tabindex="0"><span role="link">{{competence.getLang('name', transloco.getActiveLang())}}</span></td>
          <td *ngIf="inOrdering === true" >{{competence.getLang('name', transloco.getActiveLang())}}</td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="2" class="no-data">{{ t('common.labels.no_data') }}</td>
        </tr>
      </ng-template>
    </p-table>
  </div>

</app-list-view>
</ng-container>
